/* Blazing Banner builder: "How to make your banner" guide + "what you see is what we print" messaging.
   - A guide button above Step 1 opens a short step-by-step guide.
   - Under the live preview (once artwork is in): "What you see is what we print" + a shortcut into the editor.
   - Under Add to cart: a reminder that the banner prints exactly as the preview shows. */
(function () {
  'use strict';
  var root = document.getElementById('blazing-banner-builder-v43');
  if (!root) return;

  // Small drawings for each step (brand colors, no photos needed).
  var O = '#ff5a1f', INK = '#07111b', G = '#17915a', L = '#e2e6ea';
  function art(inner) { return '<svg viewBox="0 0 220 110" role="img" aria-hidden="true">' + inner + '</svg>'; }
  function banner(x, y, w, h, fill, extra) {
    return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="3" fill="' + fill + '" stroke="' + INK + '" stroke-opacity=".25"/>' +
      [[x + 4, y + 4], [x + w - 4, y + 4], [x + 4, y + h - 4], [x + w - 4, y + h - 4]].map(function (p) {
        return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="1.8" fill="#8a939c"/>';
      }).join('') + (extra || '');
  }
  function logo(cx, cy, r) {   // a round "cookie" logo stand-in
    return '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="#d99a4e" stroke="#6b3a1a" stroke-width="2"/>' +
      '<circle cx="' + (cx - r * .35) + '" cy="' + (cy - r * .2) + '" r="' + r * .14 + '" fill="#6b3a1a"/><circle cx="' + (cx + r * .3) + '" cy="' + (cy + r * .25) + '" r="' + r * .12 + '" fill="#6b3a1a"/>';
  }
  var PICS = [
    art(['3×2', '5×3', '8×4'].map(function (t, i) {
      var on = i === 1, x = 12 + i * 70;
      return '<rect x="' + x + '" y="30" width="58" height="40" rx="8" fill="' + (on ? O : '#fff') + '" stroke="' + (on ? O : L) + '" stroke-width="2"/>' +
        '<text x="' + (x + 29) + '" y="56" text-anchor="middle" font-family="Arial" font-weight="800" font-size="15" fill="' + (on ? '#fff' : INK) + '">' + t + ' ft</text>';
    }).join('') + '<text x="110" y="92" text-anchor="middle" font-family="Arial" font-size="11" fill="#6b7684">or type your own size</text>'),
    art('<rect x="18" y="22" width="44" height="58" rx="5" fill="#fff" stroke="' + INK + '" stroke-width="2"/><path d="M50 22v12h12" fill="none" stroke="' + INK + '" stroke-width="2"/>' +
      '<text x="40" y="62" text-anchor="middle" font-family="Arial" font-weight="800" font-size="10" fill="' + O + '">PNG</text>' +
      '<path d="M72 51h36m-8-7 8 7-8 7" fill="none" stroke="' + O + '" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>' +
      banner(118, 22, 90, 58, '#fbf6ec', logo(163, 51, 20))),
    art([['#fbf6ec', 'Match', 1], ['#fff', 'Whole', 0], ['#fff', 'Fill', 0]].map(function (o, i) {
      var x = 8 + i * 71;
      var inner = i === 2 ? logo(x + 31, 45, 30) : logo(x + 31, 45, 17);
      return '<g><clipPath id="bbhc' + i + '"><rect x="' + x + '" y="24" width="62" height="42" rx="3"/></clipPath>' +
        '<rect x="' + (x - 3) + '" y="21" width="68" height="48" rx="5" fill="none" stroke="' + (o[2] ? O : 'transparent') + '" stroke-width="3"/>' +
        '<g clip-path="url(#bbhc' + i + ')">' + banner(x, 24, 62, 42, o[0], inner) + '</g>' +
        '<text x="' + (x + 31) + '" y="86" text-anchor="middle" font-family="Arial" font-weight="800" font-size="11" fill="' + (o[2] ? O : INK) + '">' + (o[2] ? '✓ ' : '') + o[1] + '</text></g>';
    }).join('')),
    art(banner(30, 14, 160, 82, '#fbf6ec', logo(80, 55, 26) +
      '<rect x="54" y="29" width="52" height="52" fill="none" stroke="' + O + '" stroke-width="1.5" stroke-dasharray="3 2"/>' +
      [[54, 29], [106, 29], [54, 81], [106, 81]].map(function (p) { return '<rect x="' + (p[0] - 4) + '" y="' + (p[1] - 4) + '" width="8" height="8" fill="#fff" stroke="' + O + '" stroke-width="2"/>'; }).join('') +
      '<text x="148" y="50" text-anchor="middle" font-family="Arial Black,Arial" font-weight="900" font-size="15" fill="' + INK + '">FRESH</text>' +
      '<text x="148" y="68" text-anchor="middle" font-family="Arial Black,Arial" font-weight="900" font-size="15" fill="' + O + '">COOKIES</text>')),
    art(banner(20, 18, 130, 74, '#fbf6ec', logo(60, 55, 22) +
      '<text x="116" y="52" text-anchor="middle" font-family="Arial Black,Arial" font-weight="900" font-size="12" fill="' + INK + '">FRESH</text>' +
      '<text x="116" y="67" text-anchor="middle" font-family="Arial Black,Arial" font-weight="900" font-size="12" fill="' + O + '">COOKIES</text>') +
      '<circle cx="178" cy="55" r="24" fill="' + G + '"/><path d="M167 55l8 8 15-16" fill="none" stroke="#fff" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>')
  ];

  var STEPS = [
    ['Pick your size', 'Tap a popular size, or type your own width and height.'],
    ['Add your artwork', 'Upload your file (PDF, PNG or JPG). No file? Tap <b>Design it here</b> and make one for free.'],
    ['Pick how it fits', 'If your file is a different shape than your banner, we show you little pictures of your banner done each way. <b>Tap the one you like.</b> “Match background” fills the empty sides with <b>one solid color</b> from the edge of your file. If your background fades or has a pattern, try “Extend background”, which carries your file’s edges out to the banner’s edges.'],
    ['Change anything in the editor', 'Tap <b>Adjust it in the editor</b> to move it, make it bigger, stretch it, change the color, or add words.'],
    ['Check it, then check out', '<b>Your banner prints exactly like the preview.</b> Check the spelling and the layout, then check out.']
  ];

  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }

  function openGuide(opener) {
    var box = document.getElementById('bbhGuide');
    if (!box) {
      box = el('<div class="bbh-guide" id="bbhGuide" role="dialog" aria-modal="true" aria-labelledby="bbhTitle" hidden>' +
        '<div class="bbh-card">' +
          '<div class="bbh-head"><h2 id="bbhTitle">How to make your banner</h2>' +
          '<button type="button" class="bbh-x" data-bbh-close aria-label="Close guide">×</button></div>' +
          '<ol class="bbh-steps">' + STEPS.map(function (s, i) {
            return '<li><div class="bbh-pic">' + PICS[i] + '</div><div class="bbh-txt"><span class="bbh-n" aria-hidden="true">' + (i + 1) + '</span><div><b>' + s[0] + '</b><p>' + s[1] + '</p></div></div></li>';
          }).join('') + '</ol>' +
          '<p class="bbh-promise"><span aria-hidden="true">✓</span> What you see is what we print. We never stretch, crop or move your design unless you do it in the preview or the editor.</p>' +
          '<button type="button" class="bbh-ok" data-bbh-close>Got it</button>' +
        '</div></div>');
      document.body.appendChild(box);
      box.addEventListener('click', function (e) {
        if (e.target === box || e.target.closest('[data-bbh-close]')) closeGuide();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) closeGuide(); });
    }
    box._opener = opener || null;
    box.hidden = false;
    document.documentElement.classList.add('bbh-open');
    box.querySelector('.bbh-ok').focus();
  }

  function closeGuide() {
    var box = document.getElementById('bbhGuide');
    if (!box) return;
    box.hidden = true;
    document.documentElement.classList.remove('bbh-open');
    if (box._opener) box._opener.focus();
  }

  // 1) Guide button above Step 1.
  var sizeStep = document.getElementById('sizeStep');
  if (sizeStep && !document.getElementById('bbhGuideBtn')) {
    var bar = el('<div class="bbh-bar">' +
      '<button type="button" class="bbh-btn" id="bbhGuideBtn"><span class="bbh-q" aria-hidden="true">?</span>How to make your banner</button>' +
      '<span class="bbh-wysiwyg"><span aria-hidden="true">✓</span> Prints exactly as you see it</span></div>');
    sizeStep.parentNode.insertBefore(bar, sizeStep);
    bar.querySelector('button').addEventListener('click', function () { openGuide(this); });
  }

  // 2a) Always-visible promise right above the banner preview. It lights up briefly when a file goes in.
  // First thing inside the preview panel (the dark .stage box), so it sits right above the banner.
  var stage = root.querySelector('.stage');
  var promise = null;
  if (stage && !document.getElementById('bbhPromise')) {
    promise = el('<div class="bbh-promise-bar" id="bbhPromise" role="note">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M1.5 12S5.5 4.5 12 4.5 22.5 12 22.5 12 18.5 19.5 12 19.5 1.5 12 1.5 12z" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3.5" fill="currentColor"/></svg>' +
      '<span><b>What you see is exactly what we print.</b> <span class="bbh-promise-sub">Make sure your banner preview looks just the way you want.</span></span></div>');
    stage.insertBefore(promise, stage.firstElementChild);
  }

  // 2b) Under the preview, once artwork is in: the shortcut into the editor.
  var actions = document.getElementById('previewActionRow');
  var note = null;
  if (actions) {
    note = el('<div class="bbh-preview-note" hidden>' +
      '<span><span aria-hidden="true">✓</span> <b>This is exactly how it will print.</b> Need changes?</span>' +
      '<button type="button" class="bbh-edit">Adjust it in the editor →</button></div>');
    var matchRow = document.getElementById('bbxMatchBgRow');
    (matchRow || actions).insertAdjacentElement('afterend', note);
    note.querySelector('button').addEventListener('click', function () {
      var entry = document.getElementById('bbdEntry');
      if (entry) entry.click();
    });
    var wasShown = false;
    var sync = function () {
      var shown = getComputedStyle(actions).display !== 'none';
      note.hidden = !shown;
      // A file just went in: make the promise bar glow for a moment so it's noticed.
      if (shown && !wasShown && promise) {
        promise.classList.remove('bbh-glow');
        void promise.offsetWidth;
        promise.classList.add('bbh-glow');
      }
      wasShown = shown;
    };
    new MutationObserver(sync).observe(actions, { attributes: true, attributeFilter: ['style', 'class'] });
    sync();
  }

  // 3) Under Add to cart.
  var cart = document.getElementById('addCartBtn');
  if (cart && !document.getElementById('bbhCartNote')) {
    cart.insertAdjacentElement('afterend', el('<p class="bbh-cart-note" id="bbhCartNote">' +
      'Your banner prints exactly as the preview shows. Please check spelling and layout first.</p>'));
  }

  window.BBHelp = { open: openGuide };
})();
